import { bambiApi as sdkBambiApi } from '@bambi/api-client';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { rootReducer } from './rootReducer';
import type { RootState } from './types';
import { enhancedBambiApi } from 'src/common/external/bambi-api/enhancedBambiApi';
import { organizationPersistenceListener } from 'src/features/auth/organizationPersistence.listener';

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: { warnAfter: 150 }, // default is 32ms
        serializableCheck: { warnAfter: 150 }, // default is 32ms
      })
        .prepend(organizationPersistenceListener.middleware)
        .concat(enhancedBambiApi.middleware)
        .concat(sdkBambiApi.middleware),
    preloadedState,
  });
}

// TODO: probably can separate this stuff out, but minimizing scope of change
// by creating the store and keeping it exported below
const store = setupStore();

// From react-toolkit
// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export default store;
